import { useQuery } from "@tanstack/react-query";
import { pessoaService } from "@/services/api/PessoaService";

export function usePessoaDetail(pessoaId?: number, enabled: boolean = true) {
  const { data, isLoading, error } = useQuery({
    queryKey: ["pessoa-detail", pessoaId],
    queryFn: () => pessoaService.getPessoaById(pessoaId!),
    enabled: !!pessoaId && enabled,
    staleTime: 1000 * 60 * 10,
  });

  return { pessoa: data, isLoading, error };
}
